export enum ImageType {
  LOGO = 'logo',
  FAVICON = 'favicon',
}
